import React, { useReducer } from 'react'

export const TourContext = React.createContext()

const TOUR_STEPS = [
    {
      target: ".tour-name",
      content: "Add identifying name and quantity for the mixer you are designing.",
      disableBeacon: true
    },
    {
      target: ".tour-application",
      content: "Select correct application for your mixer. Hover over the options to see a description.\n\n Options that are bold and italic are available for online pricing. For other designs, we encourage you to continue with the online form and Sulzer would be happy to design and provide you custom pricing.",
    },
    {
      target: ".tour-element",
      content: "Select size and characteristics of your mixer element.",
    },
    {
      target: ".tour-housing",
      content: "Select characteristics of your housing. If a housing is not required for your mixer, select the Elements Only option.",
    },
    {
      target: ".tour-design",
      content: "Enter design specifications for your mixer to help Sulzer ensure design is accurate.",
    },
    {
      target: ".tour-services",
      content: "Select additional services you would like performed on the mixer and/or housing.",
    },
    {
      target: ".tour-fluid",
      content: "For new and custom mixers, we highly encourage you to enter fluid conditions to calculate pressure drop and allow Sulzer to verify design if needed.",
    },
    {
      target: ".tour-case",
      content: "Additional cases can be added as either a copy of existing case or add new.",
    },
    {
      target: ".tour-stream",
      content: "Additional streams can be added as either a copy of existing stream or add new.",
    },
    {
      target: ".tour-pressure",
      content: "If fluid conditions are present, an estimate pressure drop calculation can be performed.",
    },
    {
      target: ".tour-save",
      content: "Once design is completed, you can save the quote for future reference and to generate pricing.",
    },
    {
      target: ".tour-pricing",
      content: "Once quote is saved, pricing can be generated for all designs present.",
    },
    {
      target: ".tour-addMixer",
      content: "Feel free to add additional mixers to your quote as either a copy of current design or as a new mixer."
    },
  
  ];
  
// Define our state
const INITIAL_STATE = {
    key: new Date(),
    run: false,
    continuous: true,
    loading: false,
    stepIndex: 0,
    steps: TOUR_STEPS,
};
    
// Set up the reducer function
const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
    case "START":
        return { ...state, run: true };
    case "RESET":
        return { ...state, stepIndex: 0 };
    case "STOP":
        return { ...state, run: false };
    case "NEXT_OR_PREV":
        return { ...state, ...action.payload };
    case "RESTART":
        return {
        ...state,
        stepIndex: 0,
        run: true,
        loading: false,
        key: new Date(),
        };
    default:
        return state;
    }
};

export const TourProvider = (props) => {
    const initialState = INITIAL_STATE

    const [tourData, dispatch] = useReducer(reducer, initialState)

    const value = { tourData, dispatch }

    return <TourContext.Provider value={value}>{props.children}</TourContext.Provider>
}